/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import {
  ADD_TIMELY_ALERTS,
  REMOVE_TIMELY_ALERT,
  REMOVE_PAGE_TIMELY_ALERTS
} from './TimelyAlertActions';
import { TIMELY_ALERTS } from 'services/TimelyAlerts';

export const timelyAlertsInitialState = TIMELY_ALERTS;

/**
 * Add a list of timely alerts that follow the schema /services/timelyAlerts
 * Remove timelyAlert with the given id from state.
 * @param state: notification boxes list.
 * @param action: action.page (The page that notification box is located at)
 * @returns timelyAlerts list
 */
export const timelyAlertReducer = (state, action) => {
  switch (action.type) {
    case ADD_TIMELY_ALERTS:
      return state.concat(action.alerts);
    case REMOVE_TIMELY_ALERT:
      return state.filter((timelyAlert) => timelyAlert.id !== action.id);
    case REMOVE_PAGE_TIMELY_ALERTS:
      return state.filter((timelyAlert) => timelyAlert.page !== action.page);
    default:
      return state;
  }
};
